/**
 * 永続化スキーマ（SPEC §2.2）:
 * - 保存先: localStorage
 * - キー: `oshi-viewer:v1:selectedPlayer` に選手IDを1件保存（バージョン番号をキー名に含める）
 * - 変換に失敗した値は削除せず `oshi-viewer:v1:selectedPlayer:corrupted` へ退避する
 *
 * このファイルは純粋関数のみを持つ（I/O は `useFavoritePlayer.ts` 側で行う）。
 *
 * **Issue #9 での変更**: 選手IDの形式を「チーム略称_背番号」（例: "G_55"、モックデータ時代の形式）
 * から npb.jp の選手ID（8桁の数字。例: "41045153"）へ変更した。保存の入れ物（キー・バージョン v1・
 * 「単一の文字列を保存する」というスキーマ自体）は変わっていないため v2 への変換は不要と判断した:
 * 旧形式のIDから新形式のIDへ機械的に変換する方法が存在しない（無関係な採番体系のため）ので、
 * 既存の「破損データ退避」の仕組み（下記 `parseStoredValue`）にそのまま委ね、
 * 旧形式の値は不正な値として扱い、消さずに退避した上で未選択状態として描画する。
 */

export const STORAGE_KEY = 'oshi-viewer:v1:selectedPlayer'
export const STORAGE_KEY_CORRUPTED = 'oshi-viewer:v1:selectedPlayer:corrupted'

/** 選手ID の形式（npb.jp の選手ID。8桁の数字。例: "41045153"。ADR-0007 / Issue #9） */
const PLAYER_ID_PATTERN = /^\d{8}$/

/** 値が選手IDとして妥当な形式かを判定する純粋関数 */
export function isValidPlayerId(value: string): boolean {
  return PLAYER_ID_PATTERN.test(value)
}

/**
 * localStorage から読み出した生の値（v1 スキーマ）を検証し、選手IDへ変換する純粋関数。
 * 将来 v2 スキーマを追加する場合は、ここに `v1 -> v2` の変換ステップを足す
 * （SPEC §2.2「バージョン間の変換方針」）。
 *
 * @param raw `localStorage.getItem` の戻り値（未保存なら null）
 * @returns 妥当な選手ID、または変換できない場合は null（＝破損データ）
 */
export function parseStoredValue(raw: string | null): string | null {
  if (raw === null) return null
  if (!isValidPlayerId(raw)) return null
  return raw
}
